import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style.js";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {Messages} from "../../Messages.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {TextArea} from "../../../stem-core/src/ui/input/Input.jsx";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {authService, userService} from "../../../client/connection/Services.js";
import {redirectToMerchantHomepage} from "../../widget/misc/WidgetUtils.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {autoredraw} from "../../../stem-core/src/decorators/AutoRedraw.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";
import {apiUpdateUserMerchantPreferences} from "../../../client/state/merchant/MerchantUserStore.js";


export class ThankYouPanelStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.PANEL_TITLE;

    @styleRule
    text = {
        marginBottom: 20,
    };

    @styleRule
    center = {
        margin: "10px 0 20px",
        textAlign: "center",
    };

    @styleRule
    link = this.themeProps.PANEL_LINK;

    @styleRule
    dashboardLink = {
        ...this.themeProps.PANEL_LINK,
        fontSize: "inherit",
        textTransform: "lowercase",
    };

    @styleRule
    optionalMessage = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        marginBottom: 10,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    textArea = {
        fontSize: () => this.themeProps.MERCHANT_FONT_SIZE_NORMAL + " !important",
        width: "100%",
        padding: "12px 18px !important",
        lineHeight: "21px !important",
        resize: "none",
    };
}

@autoredraw(iFrameUserDataService)
@registerStyle(ThankYouPanelStyle)
export class ThankYouPanel extends UI.Element {
    getDonationMessage() {
        const donation = iFrameUserDataService.getLatestDonation();

        if (!donation) {
            return "";
        }

        if (donation.isRecurring()) {
            return Messages.donatePageThankYouMessageRecurring;
        }
        return Messages.donatePageThankYouMessageOneTime;
    }

    getDonationThankYou() {
        const donation = iFrameUserDataService.getLatestDonation();

        if (!donation) {
            return "";
        }

        if (donation.isRecurring()) {
            return Messages.donatePageThankYouTitleRecurring(donation.formatPrice());
        }
        return Messages.donatePageThankYouTitleOneTime(donation.formatPrice());
    }

    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            <div className={styleSheet.title}>{Messages.thankYou}</div>,
            <MessageElement className={styleSheet.text} message={this.getDonationThankYou()} />,
            <MessageElement className={styleSheet.text} message={this.getDonationMessage()} />,
            <div className={styleSheet.text}>
                {Messages.donatePageThankYouAccessDashboard}
                <Link className={styleSheet.dashboardLink} newTab href="/" value={Messages.dashboard}/>.
            </div>,
            <div className={styleSheet.optionalMessage}>{Messages.donatePageThankYouOptionalMessage}</div>,
            <TextArea ref="textArea" className={styleSheet.textArea}/>,
            <MerchantButton disabled={!this.textArea?.getValue()}
                            onClick={() => this.submitMessage()}>
                {Messages.submit}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.returnToHomepage(publicationName)} onClick={redirectToMerchantHomepage}
                      className={styleSheet.link}/>
            </div>,
            <PoweredByBlink />,
        ];
    }

    async submitMessage() {
        LoadingSpinner.show();
        try {
            await apiUpdateUserMerchantPreferences({
                userId: userService.getUserId(),
                merchantId: iFrameMerchantService.getMerchant().id,
                formResponses: JSON.stringify({
                    donationMessage: this.textArea.getValue(),
                }),
            });
            this.options.changeURL(DONATE_PAGE_URLS.thankYouMessageReceived);
        } finally {
            LoadingSpinner.hide();
        }
    }

    onMount() {
        this.textArea.addNodeListener("keyup", () => this.redraw());
        authService.onAuthenticationChange(() => {
            if (this.isInDocument() && !authService.isAuthenticated()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
